import { Backdrop } from '@mui/material';
import { styled } from '@mui/system';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

export default StyledBackdrop;
